<div *ngIf="noHeaderFooter !== undefined && !noHeaderFooter">
  <app-chatpopup></app-chatpopup>
</div>